export const data = function() {
  return {
    isDebug: true,
    loading: false,
    workOrderRequestID: 0,
    workOrderRequest: null,
    tabs: [
      { name: 'workorderRequestPromote', label: 'Request Promote' },
      { name: 'workorderRequestConversation', label: 'Conversations' }
    ],
    styles: {
      mainContainer: {
        minHeight: '1000px'
      }
    },
    transitionName: 'slide-down',
    showUploadModal: false
  }
}
